export const weightedNAPoolSet = [
  'WF-NA-POWER',
  'WF-NA-EAST',
  'WF-NA-WEST',
  'WF-NA',
];
